<template>
    <section class="m-industry-hy-form2">
        <div class="m-industry-label1">
            <div class="clearfix">
                <label class="fl">
                    <span class="u-industry-name1">姓名：</span>
                    <div class="m-industry-input1">
                        <el-input placeholder="请输入姓名" v-model="form.name" clearable></el-input>
                    </div>
                </label>
                <label class="fl">
                    <span class="u-industry-name2">研究行业：</span>
                    <el-select v-model="form.hy_id" placeholder="请选择">
                        <el-option
                            v-for="item in tagsArr"
                            :key="item.value"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </label>
            </div>
        </div>
        <label class="m-industry-label1">
            <span class="u-industry-name4">取得证券投资咨询职业资格（分析师）时间：</span>
            <div class="m-industry-input1">
                <el-date-picker
                    v-model="form.analyst_cert_time"
                    align="right"
                    type="date"
                    placeholder="选择日期"
                ></el-date-picker>
            </div>
        </label>
        <label class="m-industry-label1">
            <span class="u-industry-name1">联系方式：</span>
            <div class="m-industry-input1">
                <el-input placeholder="请输入联系方式" v-model="form.analyst_phone" clearable></el-input>
            </div>
        </label>
        <label class="m-industry-label1">
            <span class="u-industry-name1">推荐理由：</span>
            <div class="m-industry-input2">
                <el-input
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 4}"
                    placeholder="请输入内容"
                    v-model="form.recommend"
                ></el-input>
            </div>
        </label>
        <p class="u-industry-des4">注：1、此推荐理由将部分展示在最终获奖证明描述中。2、"未来之星"分析师需要在2017年9月1日（含）之后取得证券投资咨询执业资格（分析师）。</p>
        <div class="m-industry-box3">
            <a class="u-industry-btn2 fl" href="javascript:;" @click="postApply">提交</a>
            <a
                :class="['u-industry-btn2','fr',!isPrint ? 'unclick' : '']"
                href="javascript:;"
                @click="jumpAbout"
            >预览</a>
        </div>
    </section>
</template>

<script>
export default {
    name: "Form1",
    data() {
        return {
            tagsArr: {},
            // active: 0,
            // qsName: "",
            // industry: "",
            // industryDesc: "",
            form: {
                name: "",
                hy_id: 0,
                analyst_cert_time: "",
                analyst_phone: "",
                recommend: ""
            },
            isPrint: 0
        };
    },
    created() {
        this.getTags();
        this.getLists();
    },
    methods: {
        getTags() {
            var _this = this;
            // console.log(sessionStorage.getItem("acode") );
            let param = {
                url:
                    "//support.finance.sina.com.cn/service/api/openapi.php/JinQi2020Service.getConfList",
                acode: sessionStorage.getItem("acode")
                    ? sessionStorage.getItem("acode")
                    : "",
                atype: "qs",
                type: "hy"
            };
            // console.log(param);
            // 发送 POST 请求
            this.$jsonp(param.url, {
                acode: param.acode,
                atype: param.atype,
                type: param.type
            })
                .then(function(response) {
                    // console.log(response);
                    if (response.result.status.code == 0) {
                        let datas = response.result.data;
                        _this.tagsArr = datas.user;
                        // console.log(_this.tagsArr);
                        // let cur = _this.active || 0;
                        // _this.getLists(cur);
                    }
                })
                .catch(function(error) {
                    // console.log(error);
                });
        },
        // getLists(index, ele) {
        getLists() {
            var _this = this;
            // var el = ele ? ele.currentTarget : "";
            // _this.industry = el ? el.textContent : "宏观经济";
            // // console.log(el);
            // _this.industryDesc = el ? el.dataset.des : "";

            // _this.active = index;
            let param = {
                url:
                    "//support.finance.sina.com.cn/service/api/openapi.php/JinQi2020Service.getAnalyst",
                // http://support.finance.sina.com.cn/service/api/openapi.php/JinQi2020Service.getAnalyst?acode=zzzz&atype=qs
                // ?acode=ajzq_020235f9c2af&atype=qs&hy_id=1
                acode: sessionStorage.getItem("acode")
                    ? sessionStorage.getItem("acode")
                    : "",
                atype: "qs"
                // hy_id: index + 1
            };
            // 发送 POST 请求
            this.$jsonp(param.url, {
                acode: param.acode,
                atype: param.atype
                // hy_id: param.hy_id
            })
                .then(function(response) {
                    // console.log(response);
                    if (response.result.status.code == 0) {
                        let datas = response.result.data;

                        let adapterDatas = _this.adapter(datas.hy);
                        // console.log(adapterDatas);
                        _this.form = adapterDatas;
                        _this.isPrint = datas.qs.hy_total;
                    }
                })
                .catch(function(error) {
                    // console.log(error);
                });
        },
        adapter(data) {
            // if (!data.length) {
            if (!data) {
                return {
                    name: "",
                    hy_id: "",
                    analyst_cert_time: "",
                    analyst_phone: "",
                    recommend: ""
                };
            }

            // return data.reduce(function(per, cur) {
            var analyst_cert_time = new Date(data.analyst_cert_time * 1);
            var per = {
                name: data.name || "",
                hy_id: data.hy_id * 1 || "",
                analyst_cert_time: analyst_cert_time || "",
                analyst_phone: Number(data.analyst_phone) || 1,
                recommend: data.recommend || ""
            };

            return per;
            // }, []);
        },
        postApply() {
            var _this = this,
                analyst_cert_time_str = new Date(
                    this.form.analyst_cert_time
                ).getTime();
            // 发送 POST 请求

            let url =
                "//support.finance.sina.com.cn/service/api/openapi.php/JinQi2020Service.saveAnalyst";
            let param = new URLSearchParams();
            param.append("acode", sessionStorage.getItem("acode"));
            param.append("atype", "qs");
            param.append("hy_id", this.form.hy_id);
            param.append("name", this.form.name);
            param.append("analyst_cert_time", analyst_cert_time_str);
            param.append("analyst_phone", this.form.analyst_phone);
            param.append("recommend", this.form.recommend);
            // param.append("hy_name", this.form.hy_name);
            // param.append("hy_id", this.active + 1);
            // param.append("report_brief", this.form.report_brief);
            this.axios({
                method: "POST",
                url: url,
                data: param
            })
                .then(function(response) {
                    let data = response.data.result;
                    if (data.status.code == 0) {
                        _this.$message({
                            message:
                                "恭喜你，报名成功！请填写其他行业报名或预览填写内容！",
                            type: "success"
                        });
                        _this.getTags();
                    } else {
                        let msg = data.status.msg;
                        _this.$message({
                            message: msg,
                            type: "warning"
                        });
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        jumpAbout() {
            if (!this.isPrint) {
                return;
            }
            this.$confirm(
                "请提交当前填写内容后预览，预览内容为所有参选行业报名情况！",
                "提示",
                {
                    distinguishCancelAndClose: true,
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }
            )
                .then(() => {
                    this.$router.push({ path: "about" });
                })
                .catch(() => {
                    // this.$message({
                    //     type: "info",
                    //     message: "已取消删除"
                    // });
                });
        }
    }
};
</script>
